/* eslint-disable array-callback-return */
import WrapperContent from '@/components/Layout/WrapperContent';
import { Product } from '@/shared/types/product.types';
import Chip from '@/components/Layout/Chip';
import { DivContentNews } from '@/components/Internals/NewsContent/styles';
import currencyParser from '@/utils/currencyParser';
import ContentComposer from '@/components/Internals/ContentComposer';
import Breadcrumb from '@/components/Layout/Breadcrumb';
import ProductChips from '../ProductChips';
import { mglGray } from '@/styles/designSystemColors';
import OfferBanner from '@/components/Internals/OfferBanner';
import useBreakpoint from '@/hooks/useBreakpoint';
import ImageComponent from '@/components/Layout/Image';
import Icon from '@/components/Layout/Icon';

interface HeaderProps {
  dataHeader: Product;
}

export default function Header({ dataHeader }: HeaderProps) {
  const { breadcrumb, imagem, empresa, titulo, descricao, lancamento, especificacoesCabecalho, melhoresPrecos, analise, fichaTecnica, timeline, rumor } =
    dataHeader.data;
  const [isTabletOrMobile] = useBreakpoint('tablet');

  const sponsoredBrandName = 'Oppo';

  const isSponsoredBrand = empresa === sponsoredBrandName;

  return (
    <WrapperContent backgroundColor={mglGray.mglGray50} isOnHeader hasBreadcrumb>
      <OfferBanner />
      <Breadcrumb breadcrumbList={breadcrumb} />
      <div className="mb-0 mt-8 flex w-full flex-col tablet:mb-8 tablet:flex-row">
        <div className="flex flex-row items-center">
          <div className="relative flex max-h-[148px] max-w-[148px] rounded-lg border-[0.5px] border-solid border-mglGray300 p-6 md:max-h-[248px] md:max-w-[248px]">
            <ImageComponent src={imagem.url} blurhash={imagem.blurhash} width={isTabletOrMobile ? 80 : 190} height={isTabletOrMobile ? 80 : 190} />
            {rumor && (
              <span className="absolute bottom-[1.75em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-xs uppercase leading-loose text-mglGray50">
                Rumor
              </span>
            )}
          </div>
          {melhoresPrecos && melhoresPrecos?.length > 0 && (
            <div className="ml-4 flex tablet:hidden">
              <Chip
                chipSize="large"
                color="white"
                backgroundColor="green"
                borderColor="green"
                highlightedText={currencyParser(melhoresPrecos[0].preco)}
                texto="melhor preço"
                posIcon={<Icon icon="mdi:open-in-new" fontSize="0.75rem" />}
                link={melhoresPrecos[0].encurtador}
              />
            </div>
          )}
        </div>
        <div className="mt-6 flex w-full flex-col gap-1 tablet:ml-6 tablet:mt-0">
          <div className="relative mb-4 flex flex-col">
            <h2 className="text-sm font-light text-mglGray900">{empresa}</h2>
            <h1 className="font-medium text-mglGray900">{titulo}</h1>
            <div className="flex w-full flex-col justify-between tablet:flex-row [&_p+p]:flex-grow-[2] [&_p]:flex-grow-[2]">
              {lancamento?.data && (
                <p className="text-sm font-light">
                  <span className="mr-1 font-medium capitalize">Lançamento:</span>{' '}
                  {new Intl.DateTimeFormat('pt-Br', { timeZone: 'UTC' }).format(new Date(lancamento.data))}
                </p>
              )}
            </div>
          </div>
          {especificacoesCabecalho &&
            Object.keys(especificacoesCabecalho).map(specName => (
              <p className="text-sm font-light" key={specName}>
                <span className="mr-1 font-medium capitalize">{specName}:</span> {especificacoesCabecalho[specName]}
              </p>
            ))}
        </div>
      </div>
      <ProductChips
        hasDeals={melhoresPrecos && melhoresPrecos?.length > 0}
        analysis={analise?.url}
        hasOverview={!!fichaTecnica}
        hasNews={timeline && timeline?.itens?.length > 0}
        minorValue={melhoresPrecos ? melhoresPrecos[0] : null}
        sponsoredChip={isSponsoredBrand}
        key="lower-price"
      />
      <div className="mb-8 mt-8">
        <DivContentNews>
          {descricao.map(partHtml => (
            <ContentComposer
              tipo={partHtml.tipo}
              as={partHtml.tag}
              url={partHtml.url}
              target={partHtml.target}
              valor={partHtml?.valor}
              atributos={partHtml?.atributos}
              key={`${partHtml.tipo}`}
            />
          ))}
        </DivContentNews>
      </div>
    </WrapperContent>
  );
}
